var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"微课预览","visible":_vm.dialogVisible,"width":"75%","top":"10px"},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":_vm.closedlg}},[_c('iframe',{staticClass:"page-img",attrs:{"src":_vm.imgs,"frameborder":"0","allow":"autoplay","allowfullscreen":"true"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52b28a04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/Panel/weike/detail.vue
// module id = null
// module chunks = 